import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    speed: { type: Number, default: 45 },
  }

  connect() {
    this.onResize = () => this.setDuration()
    window.addEventListener("resize", this.onResize)
    this.setDuration()
  }

  disconnect() {
    window.removeEventListener("resize", this.onResize)
  }

  setDuration() {
    const distance = this.element.scrollWidth / 2
    if (!distance || !this.speedValue) return

    this.element.style.animationDuration = `${Math.round(distance / this.speedValue)}s`
  }
}
